import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "small striped toggle no-underline" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("thead", { class: "large large_padding" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, " EIN / Tax ID "),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createTextVNode(" Company "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" Name ")
    ]),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createTextVNode(" Employer "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" / Payor ")
    ]),
    /*#__PURE__*/_createElementVNode("th", null, " Name"),
    /*#__PURE__*/_createElementVNode("th", null, " Title"),
    /*#__PURE__*/_createElementVNode("th", null, " Email Address "),
    /*#__PURE__*/_createElementVNode("th", null, " Last Login "),
    /*#__PURE__*/_createElementVNode("th", null, " Type "),
    /*#__PURE__*/_createElementVNode("th", null, " Account actions ")
  ])
], -1)
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "col-md-4" }
const _hoisted_5 = { class: "col-md-4" }
const _hoisted_6 = { class: "col-md-4" }
const _hoisted_7 = { class: "col-md-4" }
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = { class: "col-md-4" }
const _hoisted_10 = { class: "col-md-4" }
const _hoisted_11 = { class: "col-md-2" }
const _hoisted_12 = { class: "actions" }
const _hoisted_13 = {
  key: 0,
  class: "tooltip-wrapper",
  "data-tooltip": "Activate User"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 1,
  class: "tooltip-wrapper",
  "data-tooltip": "Deactivate User"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", null, " / ", -1)
const _hoisted_18 = {
  class: "tooltip-wrapper",
  "data-tooltip": "Reset PIN"
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", null, " / ", -1)
const _hoisted_21 = {
  class: "tooltip-wrapper",
  "data-tooltip": "Masquerade"
}
const _hoisted_22 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertsComponent = _resolveComponent("AlertsComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AlertsComponent, { error: _ctx.error }, null, 8, ["error"]),
    _createElementVNode("table", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employers, (employer) => {
          return (_openBlock(), _createElementBlock("tr", {
            class: "large",
            key: employer.EmployerID
          }, [
            _createElementVNode("td", {
              class: "col-md-2 plan-modal",
              onClick: ($event: any) => (_ctx.openModal('edit-user', 'Employers', 'plan-profile plan-tables', null, { UserID: employer.UserID }))
            }, _toDisplayString(employer.TaxID), 9, _hoisted_3),
            _createElementVNode("td", _hoisted_4, _toDisplayString(employer.CompanyName), 1),
            _createElementVNode("td", _hoisted_5, _toDisplayString(employer.Type), 1),
            _createElementVNode("td", _hoisted_6, _toDisplayString(employer.Name), 1),
            _createElementVNode("td", _hoisted_7, _toDisplayString(employer.Title), 1),
            _createElementVNode("td", _hoisted_8, _toDisplayString(employer.Email), 1),
            _createElementVNode("td", _hoisted_9, _toDisplayString(employer.LastLogin), 1),
            _createElementVNode("td", _hoisted_10, _toDisplayString(employer.UserType), 1),
            _createElementVNode("td", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                (employer.Inactive == 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                      _createElementVNode("i", {
                        onClick: ($event: any) => (_ctx.activate(employer.UserID)),
                        class: "plan-modal fs-xs iatse-icon-noun-reset"
                      }, null, 8, _hoisted_14)
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_15, [
                      _createElementVNode("i", {
                        onClick: ($event: any) => (_ctx.deactivate(employer.UserID)),
                        class: "plan-modal iatse-icon-deactivate-user"
                      }, null, 8, _hoisted_16)
                    ])),
                _hoisted_17,
                _createElementVNode("span", _hoisted_18, [
                  _createElementVNode("i", {
                    onClick: ($event: any) => (_ctx.resetPin(employer.UserID)),
                    class: _normalizeClass(['plan-modal', 'iatse-icon-reset', { 'icon-green': employer?.DaysToExpiration === 0 }])
                  }, null, 10, _hoisted_19)
                ]),
                _hoisted_20,
                _createElementVNode("span", _hoisted_21, [
                  _createElementVNode("i", {
                    onClick: ($event: any) => (_ctx.loginAsUser(employer.UserID)),
                    class: "plan-modal iatse-icon-noun-login"
                  }, null, 8, _hoisted_22)
                ])
              ])
            ])
          ]))
        }), 128))
      ])
    ])
  ], 64))
}